import { useCallback, useMemo } from 'react';

import { useToast, type UseToastOptions } from '@frontend/components';

export const useFilesAndDirectoriesUploadToasts = (
  defaultOptions?: UseToastOptions,
) => {
  const createToast = useToast(defaultOptions);

  const createUploadNoFilesToast = useCallback(
    (options?: UseToastOptions) => {
      createToast({
        ...options,
        status: 'info',
        title: 'No compatible files found',
      });
    },
    [createToast],
  );

  const createUploadErrorToast = useCallback(
    (options?: UseToastOptions) => {
      createToast({
        ...options,
        status: 'error',
        title: 'Unable to upload file(s)',
        description: 'Failed to extract files',
      });
    },
    [createToast],
  );

  const returnValue = useMemo(
    () => ({ createUploadNoFilesToast, createUploadErrorToast }),
    [createUploadNoFilesToast, createUploadErrorToast],
  );

  return returnValue;
};
